/**
 * Games shown on the hub. Slugs must match plugin `mountPath` segments
 * (e.g. /games/paper-fly → slug paper-fly) and `server/package.json` → `stansworld.games`.
 */
export const hubGames = [
  {
    slug: 'paper-fly',
    title: 'Paper Fly',
    hint: 'Matter.js physics · WASD to steer',
    featured: true,
  },
];
